// import WebhookEndpointList from "./WebhookList";
import WebhookEndpointEdit from "./WebhookEdit";
import WebhookEndpointCreate from "./WebhookCreate";

export default {
  // list: WebhookEndpointList,
  edit: WebhookEndpointEdit,
  create: WebhookEndpointCreate,
};
